
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import {getAdditionalData, parseUtmLabels} from "~/helpers/formSend";
import errorParseNetwork from "~/helpers/errorParseNetwork";

export default BaseCmsBlock.extend({
  name: 'DirectionsCostFerryingBlock',

  data: function () {
    return {
      openItem: null
    }
  },

  computed: {
    transportList: function () {
      const _transport = [...(this.values?.items || [])]
        .map((t) => {
          return {
            value: t?.title,
            label: t?.title
          }
        })
      return _transport
    },
    isUseRecaptcha: function () {
      return Boolean(this.$store.state.appState?.config?.useReCaptchaForForms)
    },
  },

  components: {
    PopUpForm: () => import("~/cms/blocks/components/DirectionsCostFerryingBlock/PopUpForm.vue")
  },

  methods: {
    openFormFeedback: function (item) {
      this.openItem = item;
    },
    closeFormFeedback: function () {
      this.openItem = null;
    },

    submitForm: async function (form, codeRecaptcha = '') {

      const message = `Доброго времени суток, нужен расчет перевозки из города ${form.cityFrom} в город ${form.cityTo}, транспортом ${form.transport}`;
      let body = {
        type: this.values?.form_type || "Обратный звонок",
        phone: (form?.phone || "").replace(/[^\d]/g, ''),
        url: window.location.href,
        source: this.$cookies.get('sbjs_current') || '',
        additional_data: {}
      };
      if (this.isUseRecaptcha && !codeRecaptcha) {
        this.$store.commit("recaptcha/onOpen", {
          onSubmit: this.submitForm.bind(this, form)
        })
        return
      }
      if (this.isUseRecaptcha && codeRecaptcha) {
        body['g-recaptcha-response'] = codeRecaptcha;
      }

      await this.$store.commit("loading/setLoading", {name: "popUpLoading", value: true});

      const utmLabels = parseUtmLabels();
      if (utmLabels) {
        body.additional_data = {
          ...body.additional_data,
          ...utmLabels
        }
      }
      body.additional_data = await getAdditionalData({...body.additional_data}, {
        $yandexMetrika: this.$yandexMetrika
      });

      const response = await this.$api.agent.transport.post("/form/send", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {
          error: errorParseNetwork(err.response)
        }
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
        this.$toast.error(response.error);
        return
      }

      this.openItem = null;
      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$toast.success("Заявка успешно отправлена");

      if (this.values?.reach_goal) {
        this.$yandexMetrika.reachGoal(this.values?.reach_goal);
        this.$yaglaaction(this.values?.reach_goal);
      }
    },
  }
});
